// extracted by mini-css-extract-plugin
export default {"container":"culture-selector_container__OEcfh"};